/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ErrorCode } from 'client-code/grid-guide';
import { GuideError } from './GuideError';
import { ErrorTypes } from './ErrorTypes';

export class GuideRowsError extends GuideError {
    TAG: string = 'GuideRowsError';

    constructor(message: string, code: string) {
        super(code, message);
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorCode.BadRequest:
                this.code = ErrorTypes.GUIDE_ROWS_BAD_REQUEST_C1201;
                this.type = ErrorCode.BadRequest;
                break;
            case ErrorCode.DynamoDbError:
                this.code = ErrorTypes.GUIDE_ROWS_DYNAMOBD_ERROR_C1202;
                this.type = ErrorCode.DynamoDbError;
                break;
            case ErrorCode.UnexpectedError:
                this.code = ErrorTypes.GUIDE_ROWS_UNEXPECTED_ERROR_C1203;
                this.type = ErrorCode.UnexpectedError;
                break;
            default:
                this.code = ErrorTypes.GUIDE_ROWS_UNKNOWN_ERROR_C1299;
                this.type = 'GUIDE_ROWS_UNKNOWN_ERROR';
        }
    }
}
